import React from "react";
import T from "prop-types";
import ShippingFields from "MODULES/Orders/shared/ShippingFields/ShippingFields";
import { DashedSeparator } from "../../../../shared/components";
import { MISTAKE_SHIPMENT } from "../../../constants";
import { renderIf } from "../../../../shared/decorators";

function MistakeShipmentSection(props) {
  return (
    <React.Fragment>
      <DashedSeparator />
      <h2>Mistake Shipment Ship To</h2>
      <ShippingFields
        formName={props.formName}
        hasLocations={false}
        shippingFields={[
          "ship_to_type",
          "ship_to_company_id",
          "ship_to_company_address_id"
        ]}
        shippingMethod="ship_to_shipping_method"
        shippingTypes={["company", "dropship"]}
        shippingAddressField="ship_to_shipping_address"
        required={false}
      />
    </React.Fragment>
  );
}

MistakeShipmentSection.propTypes = {
  formName: T.string.isRequired
};

const isMistakeShipment = renderIf(
  ({ receivingType }) => receivingType === MISTAKE_SHIPMENT
);

export default isMistakeShipment(MistakeShipmentSection);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Create/FormSections/MistakeShipmentSection.jsx